import { Button, Input, Row, Col, Spin, message } from "antd";
import React, { useEffect, useState } from "react";
import { apiCall, fetchImage, fetchTitleImage } from "../../utils/Api";

export default function TitlePicker(props) {

    const { product= {}, setProduct = () => {}, value = "", onChange = () => { } } = props;
    const [loading, setLoading] = useState(false)

    // const [product, setProduct] = useState(injected)

    const {
        title = "",
        eisbn = "",
        authors = [],
        description = "",
        bio = []
    } = product;


    const getEANChecksum = (ean) => {
        const sum = (10 - (((Number(ean[0]) + Number(ean[2]) + Number(ean[4]) + Number(ean[6]) + Number(ean[8]) + Number(ean[10])) + ((Number(ean[1]) + Number(ean[3]) + Number(ean[5]) + Number(ean[7]) + Number(ean[9]) + Number(ean[11])) * 3)) % 10) % 10);
        return sum;
    }

    const isValidEAN = (ean) => {
        if (!/^[0-9]{13}$/.test(ean)) {
            return false;
        }
        if (Number(ean[12]) !== getEANChecksum(ean)) {
            return false; // check digit doesn't match, bad ean.
        }
        return true;
    }

    const containsISBN = (ean) => {
        if (!/^978[0-9]{10}$/.test(ean)) {
            return false;
        }
        return isValidEAN(ean);
    }


    const fetchISBN = (_isbn = value) => {

        if (!_isbn) {
            return;
        }
     
        setLoading(true)
        apiCall("title/getItem", { isbn: _isbn }, (_status, _result) => {
            if (_status) {
                onChange(_isbn);
                // api return doesn't match injected data - this maps the used keys
                setProduct({
                    eisbn : _result.eisbn,
                    title : _result.title,
                    authors : _result.authors,
                    description : _result.tab_data.description,
                    bio : _result.tab_data.bios
                });
            } else {
                message.error(<>Product <em>{_isbn}</em>  not found.</>)
            }
            setLoading(false)
        });
    }

  


    const clear = () => {
        onChange("");
        setProduct({})
    }

   
    return (
        <Spin spinning={loading}>
            {(!eisbn && 
                <Input.Search disabled={(eisbn)} defaultValue={value} enterButton="Select" onSearch={(e) => fetchISBN(e)} placeholder="ISBN..." />    
            )}
            
            {(eisbn && 
                <div>
                    <div className="shim" /><div className="shim" />
                    <Row wrap={false} gutter={5}>
                        <Col flex={"53px"}>
                        <div style={{"border" : "1px solid #ddd", "borderRadius" : '3px', "padding" : "3px", "backgroundColor" : "#fff"}}>
                            <img style={{"width" : "40px"}} src={fetchTitleImage(eisbn)} />
                        </div>
                        </Col>
                        <Col flex={"auto"}>
                            <div style={{"fontSize" : "12px", "lineHeight" : "14px"}}><strong>{title}</strong></div>
                            <div><em><small>{value}</small></em></div>
                            <div className="float-flex">
                                <div>&nbsp;</div>
                                <div><Button onClick={() => clear("")} danger size="small"><small>Remove</small></Button></div>
                            </div>
                        </Col>
                    </Row>
                </div>    
            )}
        </Spin>
    )
}